"use client";

import {
  createContext,
  type ReactNode,
  useContext,
  useMemo,
  useState,
} from "react";

type BreadcrumbContextValue = {
  contributeCatalogLabel: string;
  setContributeCatalogLabel: (label: string) => void;
};

const BreadcrumbContext = createContext<BreadcrumbContextValue | null>(null);

export function BreadcrumbProvider({ children }: { children: ReactNode }) {
  const [contributeCatalogLabel, setContributeCatalogLabel] = useState("");
  const value = useMemo(
    () => ({ contributeCatalogLabel, setContributeCatalogLabel }),
    [contributeCatalogLabel],
  );
  return (
    <BreadcrumbContext.Provider value={value}>
      {children}
    </BreadcrumbContext.Provider>
  );
}

export function useBreadcrumbContext(): BreadcrumbContextValue {
  const ctx = useContext(BreadcrumbContext);
  if (!ctx) {
    return {
      contributeCatalogLabel: "",
      setContributeCatalogLabel: () => {},
    };
  }
  return ctx;
}
